//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/Builder.js";
import "../CAM/CAM.InheritableToolDepBuilder.js";
let d=[[[1,"FanDistance",0,"CAM.InheritableToolDepBuilder",0],[0,"ManualTiltingType",1,0],[0,"ReferenceType",1,0],[0,"TiltAngle",1,0],[0,"TiltingDistanceType",1,0],[0,"TiltingDrivePoint",1,"TaggedObject",0],[0,"TiltingRotationAngle",1,0],[0,"TiltingRuleType",1,0],[0,"ToolTiltMethodType",1,0]],[[["count","curves"],"GetTiltingDriveCurve",{},0,0],[["curves"],"SetTiltingDriveCurve",{},1,0]],[]];
SPLM.CAM.ToolPathTiltTilting = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.ToolPathTiltTilting";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.ToolPathTiltTilting.ManualTiltTypes = Object.freeze({
    "KeepOriginal" : "KeepOriginal", "UserDefined" : "UserDefined"});

SPLM.CAM.ToolPathTiltTilting.ReferenceTypes = Object.freeze({
    "Initial" : "Initial", "Zm" : "Zm"});

SPLM.CAM.ToolPathTiltTilting.ToolAxisTypes = Object.freeze({
    "TowardCurve" : "TowardCurve", "FromCurve" : "FromCurve", "TowardPoint" : "TowardPoint", "FromPoint" : "FromPoint", "RelativeAngle" : "RelativeAngle"});

SPLM.CAM.ToolPathTiltTilting.ToolAxisTiltingDistTypes = Object.freeze({
    "TwoD" : "TwoD", "ThreeD" : "ThreeD"});

SPLM.CAM.ToolPathTiltTilting.ToolAxisTiltingRuleTypes = Object.freeze({
    "MainDir" : "MainDir", "AwayFrom" : "AwayFrom", "TowardConst" : "TowardConst", "Through" : "Through"});

SPLM.CAM.ToolPathTiltTilting.AxisType = Object.freeze({
    "ThreeToFive" : "ThreeToFive", "FiveToFive" : "FiveToFive"});

export default SPLM;